export default function (to: any, from: any, next: any) {
  const token = localStorage.getItem('access')
      
  if (token) next('/')
  else next()
}
